import { VesselChargeSubChargeTypePolicy } from "constants/charge/VesselChargeSubChargeTypePolicy";
import _ from "lodash";
import { ChargeDetailConstant } from "presentation/constant/ChargeDetailMaintenance/ChargeDetailConstant";
import { ChargeConstant } from "presentation/constant/ChargeHeader/ChargeConstant";
import { MessageConstant } from "presentation/constant/MessageConstant";
import { useChargeVesselVM } from "presentation/hook/ChargeDetailMaintenance/useChargeVesselVM copy";
import { useChargeDetailTracked } from "presentation/store/ChargeDetailMaintenance/ChargeDetailProvider";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { useMemo } from "react";
import { FieldType, HPHGroupRadioButton, HPHInputMask, IconButton, IFieldValue } from "veronica-ui-component/dist/component/core";
import { getChangeActionType } from "../../ChargeDetailAssist";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import { useChargeDetailVM } from "presentation/hook/ChargeDetailMaintenance/useChargeDetailVM";
import UpdateChargeVesselComp from "./UptStatusSeleteVessel/UpdateChargeVesselComp";
import { ChangeActionOptionPolicy } from "constants/charge/ChangeActionOptionPolicy";

export const ChangeActionOption = ({
    CREATE_DUMMY_VOY_CNTR: "Create Dummy Voy and Cntr as TS 1st Leg",
    CREATE_DUMMY_CNTR: "Create Dummy Voy and Cntr as TS 1st Leg",
    MAP_EXISTING_TS_LEG: "Map Existing TS Leg",
    CHANGE_CNTR_STATUS_ONLY: "Change Cntr Status Only",
});

export const CntrStatusAccordion = () => {
    const chargeDetailVM = useChargeDetailVM();
    const [chargeDetailState] = useChargeDetailTracked();
    const chargeBatchUpdate = chargeDetailState.chargeBatchUpdate;
    const chargeVesselVM = useChargeVesselVM();
    // const statusDropdownOptions = isMiUptStatusEditable(chargeDetailState.selectedChargeDetails)?.map((status) => ({
    //     dropdownLabel: status, tagLabel: status, value: status
    // }));

    const showChangeAction = useMemo(() => {

        if (!chargeBatchUpdate.status) {
            return false;
        }

        const currentUpdateStatusType = getChangeActionType(chargeBatchUpdate.status ?? "",
            chargeDetailState.selectedChargeDetails) ?? "";
        console.info("chargeBatchUpdate.status:" + chargeBatchUpdate.status);

        let subChargeType = chargeDetailState.selectedChargeDetails[0]?.subChargeType;

        if (ChangeActionOptionPolicy.chargeType.CHANGE_TYPE_4 !== currentUpdateStatusType &&
            VesselChargeSubChargeTypePolicy.CODE_CY === subChargeType) {
            if (ChangeActionOptionPolicy.chargeType.CHANGE_TYPE_1 !== currentUpdateStatusType) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }

    }, [chargeBatchUpdate.status, chargeDetailState.selectedChargeDetails])


    const showSelectVoy = useMemo(() => {

        if (!chargeBatchUpdate.status) {
            return false;
        }

        const inputId = chargeDetailState.statusOperationTypeRadioOptions?.find(item => item.key === chargeBatchUpdate.changeActionOption)?.inputId;
        const operationTypeId = (Number(inputId) - 1);

        if (ChangeActionOptionPolicy.chargeType.CHANGE_TYPE_1 === chargeBatchUpdate.updateStatusType) {
            return false;
        } else if ((ChangeActionOptionPolicy.chargeType.CHANGE_TYPE_2 === chargeBatchUpdate.updateStatusType ||
            ChangeActionOptionPolicy.chargeType.CHANGE_TYPE_3 === chargeBatchUpdate.updateStatusType) &&
            operationTypeId !== 0) {
            return true;
        } else {
            return false;
        }

    }, [chargeBatchUpdate.changeActionOption, chargeBatchUpdate.status, chargeBatchUpdate.updateStatusType, chargeDetailState.statusOperationTypeRadioOptions])

    const validateCntrStatus = () => {
        let subChargeType: string[] = [];
        chargeDetailState.selectedChargeDetails?.forEach(function (charge) {
            if (charge.subChargeType && !subChargeType.includes(charge.subChargeType)) {
                subChargeType.push(charge.subChargeType);
            }
        })
        if (subChargeType && subChargeType.length > 1) {
            return MessageConstant.charge.DIFFERENCE_SUB_CHARGE_TYPES;
        }
    }

    const calcShowSelectVsl = (changeActionOption: string) => {
        console.info("changeActionOption: " + changeActionOption);
        const inputId = chargeDetailState.statusOperationTypeRadioOptions?.find(item => item.key === changeActionOption)?.inputId;
        const operationTypeId = (Number(inputId) - 1);
        // let receiveDatetime = null;
        chargeVesselVM.onFieldChange({ 'changeActionOption': changeActionOption, 'operationTypeIndex': operationTypeId }, chargeBatchUpdate, "chargeBatchUpdate");
    };

    const calcShowChangeAction = (newStatus: string) => {
        if (newStatus) {
            const currentUpdateStatusType = getChangeActionType(newStatus ?? "",
                chargeDetailState.selectedChargeDetails) ?? "";
            chargeDetailVM.handleStatusChanged(newStatus, currentUpdateStatusType);
        }
    };

    const handleCoVslVoy = () => {
        chargeDetailVM.onShowPanel();
    }

    return (
        <>
            <CriteriaItemContainer>
                <div className='im-flex-row-item' style={{ minWidth: "150px", maxWidth: "330px", width: "100%", marginBottom: '24px' }}>
                    <NbisCommonField
                        errorMessages={validateCntrStatus() ?? ""}
                        isReadOnly={false}
                        isShowOptional={false}
                        readOnlyValue={chargeBatchUpdate.status ?? ""}
                        fieldValue={chargeBatchUpdate.status}
                        fieldLabel={ChargeDetailConstant.Charge.CNTR_STATUS}
                        isSaveClicked={false}
                        fieldType={FieldType.DROPDOWN}
                        fieldKey={'status'}
                        maxLength={60}
                        options={chargeDetailState.dynamicOptions.uptCntrStatusDropdownOptions}
                        requiredFieldList={[]}
                        onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                            calcShowChangeAction(fieldValue && !_.isArray(fieldValue) ? fieldValue.toString() ?? "" : "")}
                    />
                </div>
            </CriteriaItemContainer>
            {showChangeAction &&
                <CriteriaItemContainer>

                    <div className='im-flex-row-item' style={{ marginBottom: '24px' }}>
                        <HPHGroupRadioButton
                            label={ChargeDetailConstant.Charge.CHANGE_ACTION}
                            disabled={!showChangeAction}
                            value={chargeBatchUpdate.changeActionOption ?? ""}
                            radioOptions={chargeDetailState.statusOperationTypeRadioOptions}
                            orientation={'vertical'}
                            onChange={(e) => {
                                calcShowSelectVsl(e.key);
                            }}
                            checked={chargeDetailState.statusOperationTypeRadioOptions?.find(item => item.key === chargeBatchUpdate.changeActionOption)?.name}
                        />
                    </div>
                </CriteriaItemContainer>
            }

            {showSelectVoy &&
                <CriteriaItemContainer>
                    <div className={"customContainer"}>
                        <div className='im-flex-row-item' style={{ minWidth: "150px", maxWidth: "330px", width: "100%", marginBottom: '24px' }}>
                            <HPHInputMask
                                label={ChargeConstant.Charge.CO_VSL_VOY}
                                disabled={true}
                                optional={false}
                                helpIcon={true}
                                toolTipText={"If Co/Vsl/Voy is not inputted, dummy vessel for TS leg will be created."}
                                width="100%"
                                value={{
                                    co: chargeBatchUpdate.consortiumCode ?? '',
                                    vsl: chargeBatchUpdate.vesselCode ?? '',
                                    voy: chargeBatchUpdate.voyageCode ?? ''
                                }}
                                fieldConfiguration={{
                                    co: { maxLength: 4, autoComplete: "off", valueInNormalCase: true, isNumeric: false },
                                    vsl: { maxLength: 10, autoComplete: "off", valueInNormalCase: true, isNumeric: false },
                                    voy: { maxLength: 10, autoComplete: "off", valueInNormalCase: true, isNumeric: false },
                                }}
                                onDataChange={(e: any) => chargeVesselVM.onCoVslVoyChange(e, {
                                    co: 'consortiumCode',
                                    vsl: 'vesselCode',
                                    voy: 'voyageCode'
                                })} />
                        </div>
                        <div className='password-eye manual-dtl-coVslVoy'>
                            <IconButton fileName="Icon-more" tooltipDisable={true} size="medium" disabled={false} onClick={handleCoVslVoy} /></div>
                    </div>
                </CriteriaItemContainer>}
            <>
                {chargeDetailState.isShowFindVesselPanel && <UpdateChargeVesselComp chargeDetailState={chargeDetailState} updateStatusType={chargeBatchUpdate.updateStatusType ?? ""} />}
            </>
        </>
    )
}